/**
 * Hardware Secure Decode Robustness.
 *
 * @group DRM
 *
 * @beta
 */
export const HW_SECURE_DECODE = 'HW_SECURE_DECODE';
//# sourceMappingURL=HW_SECURE_DECODE.js.map